/* gr-cart-drawer-bootstrap.js — Lazy loader for gr-cart-drawer.js (~35 KB).
 *
 * The full cart drawer JS is parsed on every page in the original setup
 * even though shoppers don't open the drawer on most pages. This shim
 * defers it to:
 *   - idle time (requestIdleCallback, 3s timeout) — loads in background
 *   - first cart-icon click ([data-gr-cart-open]) — loads on demand
 *   - first gr:cart:open event (e.g. fired by Quick Add after ATC) —
 *     loads and replays the event after the script finishes parsing
 *
 * Read the URL from window.GR_CART_DRAWER_URL (set inline in theme.liquid
 * via {{ 'gr-cart-drawer.js' | asset_url }}) so the asset hash stays
 * correct across deploys.
 */
(function () {
  'use strict';

  var url = window.GR_CART_DRAWER_URL;
  if (!url) return;

  var loaded = false;
  var pendingOpen = false;

  function load() {
    if (loaded) return;
    loaded = true;
    // Inject the drawer's CSS at the same moment as its JS so the styles
    // are present by the time the drawer opens. Kept off the critical path
    // (not render-blocking in <head>) since the drawer is hidden at load.
    var cssUrl = window.GR_CART_DRAWER_CSS;
    if (cssUrl && !document.querySelector('link[data-gr-cart-css]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = cssUrl;
      l.setAttribute('data-gr-cart-css', '');
      document.head.appendChild(l);
    }
    var s = document.createElement('script');
    s.src = url;
    s.defer = true;
    s.onload = function () {
      // If a gr:cart:open arrived before the full JS attached its
      // listener, replay it now so the drawer actually opens.
      if (pendingOpen) {
        pendingOpen = false;
        window.dispatchEvent(new CustomEvent('gr:cart:open'));
      }
    };
    s.onerror = function () {
      // Recover from a load failure so a later trigger can retry.
      loaded = false;
    };
    document.head.appendChild(s);
  }

  // Background preload at idle. 3s timeout caps the wait on idle-starved
  // pages so the JS still arrives before a likely interaction.
  if (window.requestIdleCallback) {
    window.requestIdleCallback(load, { timeout: 3000 });
  } else {
    setTimeout(load, 1500);
  }

  // Cart icon click + any link to /cart — load on demand. We don't
  // preventDefault, so on the rare first-click-before-load case the
  // browser navigates to /cart as a graceful fallback (full JS would
  // intercept and open the drawer instead). Once loaded, the full JS's
  // own click delegation takes over.
  var CART_HREF_RE = /^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart(\?.*)?$/;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-gr-cart-open]')) { load(); return; }
    var link = t.closest('a[href]');
    if (link) {
      var href = (link.getAttribute('href') || '').replace(/^https?:\/\/[^/]+/, '');
      if (CART_HREF_RE.test(href)) load();
    }
  }, true);

  // ATC form submit (action contains /cart/add) — same idea: trigger
  // the load so the full JS can AJAX-submit on subsequent attempts.
  // First submit before idle-load completes falls through to the
  // normal form action.
  var CART_ADD_RE = /^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart\/add/;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !(f instanceof HTMLFormElement)) return;
    var action = (f.getAttribute('action') || '').replace(/^https?:\/\/[^/]+/, '');
    if (CART_ADD_RE.test(action)) load();
  }, true);

  // gr:cart:open event (Quick Add fires this after a successful ATC).
  // If the full JS isn't ready yet, buffer the event and replay on load.
  window.addEventListener('gr:cart:open', function () {
    if (!loaded) {
      pendingOpen = true;
      load();
    }
  }, true);
})();
